import { Bar } from 'react-chartjs-2'

import { ChartOptions } from 'chart.js'

const DATASET_COLORS = ['#EAF200', '#6ECBFA', '#FFB800', '#8B5CF6', '#EC4899']

const chartOpts: ChartOptions<'bar'> = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false
  },
  plugins: {
    legend: {
      display: true,
      position: 'top',
      align: 'end',
      labels: {
        color: '#34414F',
        font: { size: 12 },
        boxWidth: 12,
        boxHeight: 12,
        padding: 8,
        usePointStyle: false
      }
    },
    tooltip: {
      backgroundColor: 'rgba(2, 6, 23, 0.95)',
      titleFont: { family: "'JetBrains Mono', monospace", size: 11, weight: 'bold' },
      bodyFont: { family: "'JetBrains Mono', monospace", size: 11 },
      padding: 8,
      cornerRadius: 4,
      borderColor: 'rgba(6,182,212,0.2)',
      borderWidth: 1,
      displayColors: true
    }
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: { font: { size: 10 }, color: '#34414F', maxRotation: 0 }
    },
    y: {
      beginAtZero: true,
      border: { display: false },
      grid: { color: '#E4E8EE' },
      ticks: { font: { size: 10 }, color: '#34414F', padding: 6, count: 6 }
    }
  }
}

interface Props {
  labels: string[]
  items: {
    title: string
    values: (string | number)[]
  }[]
  single?: boolean
}

const BarChart = ({ labels, items, single = false }: Props) => {
  const options = single
    ? {
        ...chartOpts,
        layout: {
          padding: { top: 28 }
        },
        plugins: {
          ...chartOpts.plugins,
          legend: { display: false }
        }
      }
    : chartOpts

  return (
    <Bar
      data={{
        labels,
        datasets: single
          ? [
              {
                label: 'DataSets',
                data: items.map((item) => item.values[0]),
                backgroundColor: DATASET_COLORS,
                borderRadius: 2,
                borderSkipped: false
              }
            ]
          : items.map((item, i) => ({
              label: item.title,
              data: item.values,
              backgroundColor: DATASET_COLORS[i % DATASET_COLORS.length],
              borderRadius: 2,
              borderSkipped: false
            }))
      }}
      options={options}
    />
  )
}

export default BarChart
